module.exports = __webpack_public_path__ + "img/the-death-of-vivek-oji.ec08b484.png";